<!-- Package Details -->
<div *ngIf="selectedPackage; else loading" class="max-w-4xl mx-auto p-8 bg-white rounded-lg shadow-xl border border-gray-200 mt-12">
  <h1 class="text-4xl font-extrabold text-center text-gray-900 mb-6">Package Details</h1>

  <!-- Package Information Section -->
  <div class="space-y-8">

    <!-- Package ID -->
    <div class="flex justify-between p-5 bg-gradient-to-r from-blue-50 to-green-50 rounded-lg shadow-md border border-gray-300">
      <span class="text-lg font-semibold text-gray-800">Package ID:</span>
      <p class="text-lg font-semibold text-gray-900">{{ selectedPackage?.id }}</p>
    </div>

    <!-- Package Name -->
    <div class="flex justify-between p-5 bg-gradient-to-r from-blue-50 to-green-50 rounded-lg shadow-md border border-gray-300">
      <span class="text-lg font-semibold text-gray-800">Package Name:</span>
      <p class="text-lg font-semibold text-gray-900">{{ selectedPackage?.name }}</p>
    </div>

    <!-- Package Description -->
    <div class="flex justify-between p-5 bg-gradient-to-r from-blue-50 to-green-50 rounded-lg shadow-md border border-gray-300">
      <span class="text-lg font-semibold text-gray-800">Description:</span>
      <p class="text-lg font-semibold text-gray-900">{{ selectedPackage?.description }}</p>
    </div>

    <!-- Package Status -->
    <div class="flex justify-between p-5 bg-gradient-to-r from-blue-50 to-green-50 rounded-lg shadow-md border border-gray-300">
      <span class="text-lg font-semibold text-gray-800">Status:</span>
      <span
        class="px-6 py-2 text-sm font-semibold rounded-full inline-block"
        [ngClass]="{
          'bg-green-500 text-white': selectedPackage.status === 'active',
          'bg-red-500 text-white': selectedPackage.status === 'inactive',
          'bg-yellow-500 text-white': selectedPackage.status === 'pending'
        }"
      >
        {{ selectedPackage?.status | titlecase }}
      </span>
    </div>

    <!-- Package Components Section -->
    <div *ngIf="selectedPackage?.components?.length; else noComponents">
      <div class="p-5 bg-gradient-to-r from-blue-50 to-green-50 rounded-lg shadow-md border border-gray-300">
        <h3 class="text-xl font-semibold text-gray-700">Components:</h3>
        <ul class="mt-3 space-y-4 text-lg text-gray-900">
          <li *ngFor="let component of selectedPackage?.components" class="flex justify-between items-center">
            <strong class="font-medium text-gray-800">{{ component?.name }}:</strong>
            <span class="font-medium text-gray-900">{{ component?.price | currency }}</span>
          </li>
        </ul>
      </div>
    </div>

    <!-- No Components Available -->
    <ng-template #noComponents>
      <p class="italic text-gray-500">No components available</p>
    </ng-template>
  </div>

  <!-- Close Modal Button -->
  <div class="mt-8 text-center">
    <button
      (click)="closeModal()"
      class="px-8 py-4 bg-gradient-to-r from-red-400 to-red-600 text-white font-bold rounded-lg shadow-lg hover:bg-gradient-to-r hover:from-red-500 hover:to-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 transition duration-300 transform hover:scale-105"
    >
      ← Back
    </button>
  </div>
</div>

<!-- Loading Template -->
<ng-template #loading>
  <div class="flex justify-center items-center min-h-screen bg-gradient-to-r from-blue-100 to-green-100">
    <p class="text-xl text-gray-600 animate-pulse">Loading...</p>
  </div>
</ng-template>
